import { NewOpportunity } from '../../lib/types'

const baseOpportunityInitialValues: NewOpportunity = {
  opportunity_title: '',
  opportunity_slug: '',
  opportunity_domain: '',
  jurisdiction: 'United Arab Emirates',
  currency_code: '',
  is_featured: false,
  asset_class: 'Private Equity',
  sector_id: null,
  status: 'UNPUBLISHED',
  opportunity_summary: '',
  short_opportunity_summary: '',
  closing_date: null,
  investment_return: 0,
  ticket_size: 0,
  documents: [
    {
      title: '',
      url: '',
    },
  ],
  metadata: {
    company: {},
    portfolio_service_fee: '',
    asset_fee: '',
    trail_commission: '',
    upfront_commission: '',
    hurdle_rate: '',
    carry_rate: '',
    stock_nse: '',
    stock_bse: '',
    underlying_fund: '',
    securities_offering: '',
    reference_valuation: null,
    termsheet_agreement_template_url: '',
    termsheetFieldMapping: {},
    is_fixed_income: false,
    request_allocation_enabled: false,
    highlight_enabled: false,
    price_per_share: '',
    sales_fee_percent: '',
  },
  cover_image: '',
  logo_image: '',
  logo_wide_image: '',
  marketing_signup_enabled: false,
  marketing_signup_image: '',
  marketing_signup_mobile_image: '',
  transfer_page_enabled: true,
  secondary_trading_enabled: false,
  raise_goal: null,
  is_public: true,
  asset_class_data: {
    payout_frequency: null,
    investment_period_in_days: null,
    interest_charged_by_credibila_to_opportunity_percent: null,
    expected_spread_percent: null,
    days_from_withdraw_request_to_payment: null,
    exit_load_percent: null,
    profit_sharing_to_credibila_percent: null,
    hosting_fee_percent: null,
    has_lock_in_period: false,
    lock_in_period_in_days: null,
    management_fee_percent: null,
    total_shares: null,
    early_redemption_allowed: false,
    redemption_notice_in_days: null,
    redemption_fee_percent: null,
    redemption_period: null,
    redemption_gate_percent: null,
  },
  investment_period_in_days: null,
  interest_charged_by_credibila_to_opportunity_percent: null,
  expected_spread_percent: null,
  days_from_withdraw_request_to_payment: null,
  exit_load_percent: null,
  profit_sharing_to_credibila_percent: null,
  hosting_fee_percent: null,
  has_lock_in_period: false,
  lock_in_period_in_days: null,
  management_fee_percent: null,
  total_shares: null,
}

export const opportunityInitialValues: NewOpportunity = baseOpportunityInitialValues

export const createOpportunityInitialValues = (): NewOpportunity => ({
  ...baseOpportunityInitialValues,
  metadata: {
    ...baseOpportunityInitialValues.metadata,
    company: { ...baseOpportunityInitialValues.metadata.company },
    termsheetFieldMapping: { ...baseOpportunityInitialValues.metadata.termsheetFieldMapping },
  },
  documents: baseOpportunityInitialValues.documents.map((document) => ({ ...document })),
  asset_class_data: {
    ...baseOpportunityInitialValues.asset_class_data,
  },
})
